export default [
    {
        id: 1,
        title: "Tinder",
        coverImg: "tinder.webp",
        route: "tinder",

    },
    {
        id: 2,
        title: "Bumble",
        coverImg: "bumble.webp",
        route: "bumble",
    },
    
]